import type { KeyboardEventHandler } from 'react'
import React, { useState } from 'react'
import { useTableContext } from '../Context'
import { TextInput } from '@ztechapps/webui.input'
import { useTableFilterContext } from './Context'
import { FilterContainerBodyLayout } from './FilterContainer'
import type { TableFilterProps } from './types'

export const TextTableFilter = ({ field, focusRef }: TableFilterProps) => {
  const { listResult } = useTableContext()
  const { onFilter, getStoredFilter, setShowFilterContainer } = useTableFilterContext()

  const [textValue, setTextValue] = useState(getStoredFilter()?.['$regex'])

  const filterNow = () => {
    //if there is no value of textValue cast it to empty string
    const extraFilter = { [field.name]: { $options: 'i', $regex: textValue ?? '' } }
    onFilter(extraFilter)
  }

  const onKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      filterNow()
      setShowFilterContainer(false)
    }
  }

  return (
    <FilterContainerBodyLayout onOk={filterNow}>
      <TextInput
        type="search"
        onKeyDown={onKeyDown}
        disabled={listResult.loading}
        placeholder={`Search ${field.displayName}`}
        value={textValue ?? ''}
        onChange={(e) => setTextValue(e.target.value)}
        inputRef={focusRef}
        autoFocus={false}
      />
    </FilterContainerBodyLayout>
  )
}
